var _defs, _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgIconRequest = function SvgIconRequest(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#f8f8f8;opacity:0;}.b{fill-rule:evenodd;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-954 -585)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 24,
    height: 24,
    transform: "translate(954 585)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(56 -0.762)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-1989,6512a1.009,1.009,0,0,1-.708-.292A1,1,0,0,1-1990,6511a1,1,0,0,1,.292-.708A1,1,0,0,1-1989,6510h2a.994.994,0,0,1,.706.292,1,1,0,0,1,.294.708,1,1,0,0,1-.294.708,1,1,0,0,1-.706.292Zm0-4a1,1,0,0,1-.708-.292A.993.993,0,0,1-1990,6507a1,1,0,0,1,.292-.708A1,1,0,0,1-1989,6506h5a1,1,0,0,1,.708.292,1,1,0,0,1,.292.708.993.993,0,0,1-.292.706,1,1,0,0,1-.708.292Z",
    transform: "translate(2896 -5915.738)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M60,61.762l-3.6,2.7a1,1,0,0,0-.368.546.97.97,0,0,0-.032.219V75.262a5,5,0,0,0,5,5H75a5,5,0,0,0,5-5V65.227a1,1,0,0,0-.4-.766l-3.6-2.7v-.5a4,4,0,0,0-4-4H64a4,4,0,0,0-4,4Zm14-.5v7l-4.039,3.485a3,3,0,0,1-3.922,0L62,68.262v-7a2,2,0,0,1,2-2h8a2,2,0,0,1,2,2ZM60,66.531l-1.406-1.214L60,64.262Zm16-2.269v2.269l1.406-1.214Zm-4.731,9L78,67.447v7.815a3,3,0,0,1-3,3H61a3,3,0,0,1-3-3V67.447l6.731,5.815a5,5,0,0,0,6.538,0Z",
    transform: "translate(842 529)"
  })))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconRequest, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon-request.b75e4b8e.svg";
export { ForwardRef as ReactComponent };